import strategyData from "../plugins/strategy";
import strategyEn from "../plugins/strategy-en";
import GuideList from "../plugins/guide";

/** 根据当前语言合并攻略展示字段 */
export function mapStrategyItem(item, locale) {
  const isEn = locale === "en-US";
  const en = strategyEn[item.id] || {};
  return {
    ...item,
    title: isEn ? en.title || item.title : item.title,
    intro: isEn ? en.intro || item.intro : item.intro,
    content: isEn ? en.content || item.content : item.content,
  };
}

export function getStrategyById(id, locale) {
  const item = strategyData.find((ele) => String(ele.id) === String(id));
  return item ? mapStrategyItem(item, locale) : {};
}

export function getStrategyList(locale) {
  return strategyData.map((item) => mapStrategyItem(item, locale));
}

/** 合并一站式旅游服务图片数据与 i18n 文案 */
export function getGuideContent(type, i18n) {
  const raw = GuideList[type];
  if (!raw) return { introList: [], caseList: [] };

  const localeGuide = i18n.messages[i18n.locale].guide[type] || {
    intro: [],
    swiper: [],
  };

  const introList = raw.intro.map((item, index) => ({
    ...item,
    title: localeGuide.intro[index]?.title || "",
    desc: localeGuide.intro[index]?.desc || "",
  }));

  const caseList = raw.swiper.map((item, index) => ({
    ...item,
    title: localeGuide.swiper[index]?.title || item.title || "",
  }));

  return { introList, caseList };
}
